import React, { useState } from 'react'

import SearchIcon from '@mui/icons-material/Search'
import { Box, Grid, TextField, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import ButtonComponent from '../ButtonComponent'

const useStyles = makeStyles((theme: Theme) => ({
  inputFieldContainer: {
    background: 'rgba(200, 200, 200, 0.5)',
    borderRadius: '4px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '5px',
    marginBottom: '5px',
    maxHeight: 'fit-content',
  },
  iconProps: {
    color: '#c8c8c8',
    marginTop: '5px',
    paddingLeft: '4px',
  },
  input: {
    '& .MuiInput-input': {
      height: '22px',
    },
  },
  searchButton: {
    width: '100%',
    right: 0,
  },
  button: {
    height: '46px',
  },
}))

interface IProps {
  destination?: string
  setPosition: (position: { lat: number, long: number }) => void
}

const LocationSearch: React.FC<IProps> = (props) => {
  const classes = useStyles()
  const [searchValue, setSearchValue] = useState(props.destination)

  const fetchAltLong = () => {
    const query =
      'https://nominatim.openstreetmap.org/search?q=' + searchValue + '&format=json&polygon=1&addressdetails=1'
    fetch(
      query,
    ).then(
      (result) => {
        result.json().then((json) => {
          props.setPosition({ lat: json[0].lat, long: json[0].lon })
        })
      },
    )
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={8}>
        <Box component='div' className={classes.inputFieldContainer}>
          <Box component='div'>
            <SearchIcon className={classes.iconProps} />
          </Box>
          <TextField
            className={classes.input}
            autoFocus
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && fetchAltLong()}
            placeholder='Wo soll es hingehen?'
            margin='none'
            id='name'
            type='text'
            fullWidth
            variant='standard'
            InputProps={{ disableUnderline: true }}
          />
        </Box>
      </Grid>
      <Grid className={classes.searchButton} item xs={4}>
        <ButtonComponent fullWidth onClick={() => fetchAltLong()} text='Suchen' className={classes.button} />
      </Grid>
    </Grid>
  )
}

export default LocationSearch
